/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import jsCookie from 'js-cookie' // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.

Vue.use(Vuex)

// Load store modules dynamically.
const requireContext = require.context('./models', false, /.*\.js$/)

const modules = requireContext.keys()
  .map(file => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
  .reduce((modules, [name, module]) => {
    if (module.namespaced === undefined) {
      module.namespaced = true
    }

    return { ...modules, [name]: module }
  }, {})

const vuexStorage = new Vuex.Store({
  modules,
  plugins: [
    createPersistedState({
      key: 'app-storage',
      storage: {
        getItem: key => jsCookie.get(key),
        setItem: (key, value) => {
          return jsCookie.set(key, value, {
            expires: 1,
            strict: true
          })
        },
        removeItem: key => jsCookie.remove(key),
      },
      fetchBeforeUse: true
    }),
  ],
  strict: process.env.DEV,
})

export default vuexStorage
